import { removeEmptyEntries } from "../../utils/objectUtils";
import { API } from "./types";
import { fetchResource } from "./utils";

export const getTransfers = async (query?: FixMeLater) => {
  return fetchResource<API.Transfer[]>("/transfers/list", {
    queryParams: removeEmptyEntries(query) || {},
  });
};
